<template>
  <BaseDialog
    title="Выбрать тип новой работы"
    :dialog="dialog"
    :persistent="false"
    :is-invalid="$v.$invalid"
    @close="closeModal"
    @save="createCommonWork"
  >
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-4 mb-5"
        :size="50"
        color="primary"
        indeterminate
      />
    </div>

    <UIAutocomplete
      v-else
      v-model="commonWork.workType"
      class="mb-2"
      label="Тип работы"
      placeholder="Выберите тип работы"
      return-object
      :items="commonWorkWithExcludedType"
      :no-filter="false"
      item-value="id"
      item-text="name"
      :error-messages="errorMessages.workType"
      @input="$v.commonWork.workType.$touch()"
    />
  </BaseDialog>
</template>

<script>
import UIAutocomplete from '../../ui/UIAutocomplete'
import BaseDialog from '../../ui/BaseDialog'
import { required } from 'vuelidate/lib/validators'
import { setValidateMessages } from '@/scripts/validation'
import { mapActions, mapGetters } from 'vuex'
import { CommonWork } from '@/models'

export default {
  components: { BaseDialog, UIAutocomplete },
  props: {
    dialog: Boolean
  },

  data: () => ({
    commonWork: new CommonWork(),
    dataLoaded: false
  }),

  validations() {
    return {
      commonWork: {
        workType: { required }
      }
    }
  },

  computed: {
    ...mapGetters('workTypes', ['workTypes']),

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.commonWork.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.commonWork[key])
      })

      return allErrors
    },

    commonWorkWithExcludedType() {
      return this.workTypes.filter(item => item.id !== 19)
    }
  },

  methods: {
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      await this.getWorkTypes()
      this.dataLoaded = true
    },

    createCommonWork() {
      this.$emit('createCommonWork', this.commonWork.workType)
    },

    resetModal() {
      this.$v.$reset()
      this.commonWork = new CommonWork()
    },

    closeModal() {
      this.resetModal()
      this.$emit('closeModal')
    }
  },

  watch: {
    dialog(val) {
      if (val) this.getData()
      if (!val) this.resetModal()
    }
  }
}
</script>

<style scoped></style>
